import { createApiAction } from 'src/api';
import { getToken } from 'src/auth';

import { api } from 'src/api/config';

const API_BASE_URL = api.hostname;

export const FETCH_PAYMENT_PRODUCTS_START =
  'payment/fetch_payment_products_start';
export const FETCH_PAYMENT_PRODUCTS_SUCCESS =
  'payment/fetch_payment_products_success';
export const FETCH_PAYMENT_PRODUCTS_FAILURE =
  'payment/fetch_payment_products_failure';

export const ADD_PAYMENT_PRODUCTS_START = 'payment/add_payment_products_start';
export const ADD_PAYMENT_PRODUCTS_SUCCESS =
  'payment/add_payment_products_success';
export const ADD_PAYMENT_PRODUCTS_FAILURE =
  'payment/add_payment_products_failure';

export const FETCH_MERCHANT_FEES_REQUEST = 'payment/fetch_merchant_fees_request';
export const FETCH_MERCHANT_FEES_SUCCESS = 'payment/fetch_merchant_fees_success';
export const FETCH_MERCHANT_FEES_ERROR = 'payment/fetch_merchant_fees_error';

export const FETCH_MERCHANT_TERMINALS_REQUEST = 'payment/fetch_merchant_terminals_request';
export const FETCH_MERCHANT_TERMINALS_SUCCESS = 'payment/fetch_merchant_terminals_success';
export const FETCH_MERCHANT_TERMINALS_ERROR = 'payment/fetch_merchant_terminals_error';

export const fetchPaymentProducts = () =>
  createApiAction(
    {
      path: `/api/v1/payment_products/`,
    },
    [
      FETCH_PAYMENT_PRODUCTS_START,
      FETCH_PAYMENT_PRODUCTS_SUCCESS,
      FETCH_PAYMENT_PRODUCTS_FAILURE,
    ]
  );

export const addPaymentProduct = ({
  name,
  isVmd,
  isAmex,
  isCardServices,
  isDefault,
}) =>
  createApiAction(
    {
      path: `/api/v1/payment_products/`,
      method: 'POST',
      body: {
        payment_product_name: name,
        payment_product_is_vmd: isVmd,
        payment_product_is_amex: isAmex,
        payment_product_is_card_services: isCardServices,
        payment_product_is_default: isDefault,
      },
    },
    [
      ADD_PAYMENT_PRODUCTS_START,
      ADD_PAYMENT_PRODUCTS_SUCCESS,
      ADD_PAYMENT_PRODUCTS_FAILURE,
    ]
  );

export const fetchMerchantFees =
  ({ fi, account }) =>
  async (dispatch, getState) => {
    dispatch({ type: FETCH_MERCHANT_FEES_REQUEST });
    try {
      const state = getState();
      const token = getToken(state);

      const url = `${API_BASE_URL}/api/v1/transactions/merchant-fees/${fi}/${account}/`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token.accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      dispatch({
        type: FETCH_MERCHANT_FEES_SUCCESS,
        payload: data.fee_configuration,
      });
    } catch (error) {
      dispatch({
        type: FETCH_MERCHANT_FEES_ERROR,
        payload: error.message,
      });
    }
  };

export const fetchMerchantTerminals =
  ({ fi, account }) =>
  async (dispatch, getState) => {
    dispatch({ type: FETCH_MERCHANT_TERMINALS_REQUEST });
    try {
      const state = getState();
      const token = getToken(state);

      const url = `${API_BASE_URL}/api/v1/transactions/merchant-terminals/${fi}/${account}/`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token.accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      dispatch({
        type: FETCH_MERCHANT_TERMINALS_SUCCESS,
        payload: data.terminals,
      });
    } catch (error) {
      dispatch({
        type: FETCH_MERCHANT_TERMINALS_ERROR,
        payload: error.message,
      });
    }
  };

